<template>
  <validation-provider
    :name="name"
    :rules="validate"
    v-slot="{ errors, invalid, validated }"
    :mode="validateMode"
    slim
  >
    <vvs-control-wrapper
      :label="label"
      :description="description"
      :is-required="isRequired"
      :error="errors[0]"
      :loading="loading"
      :normal-label="normalLabel"
    >
      <textarea
        v-model="proxy"
        @input="onInput($event)"
        :class="{
          error: validated && invalid,
          two_line: twoLine,
          'no-height': noHeight || autoResize || !!rows,
        }"
        v-bind="formControlOptions"
        :rows="rows"
      ></textarea>
    </vvs-control-wrapper>
  </validation-provider>
</template>

<script>
import formControlMixin from '@/mixins/form.control.mixin';
export default {
  name: 'VvsTextarea',
  mixins: [formControlMixin],
  props: {
    twoLine: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: [String, Number],
    },
    noHeight: {
      type: Boolean,
      default: false,
    },
    autoResize: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resizeTextarea(event) {
      event.target.style.height = 'auto';
      event.target.style.overflowY = 'hidden';
      event.target.style.height = event.target.scrollHeight + 'px';
    },
  },
  mounted() {
    if (this.autoResize)
      this.$el.addEventListener('input', this.resizeTextarea);
  },
  destroyed() {
    if (this.autoResize)
      this.$el.removeEventListener('input', this.resizeTextarea);
  },
};
</script>
